(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5190],{

/***/ 48983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),

/***/ 44286:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 23933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),

/***/ 40180:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(14259);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 62689:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 88016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiSize = __webpack_require__(48983),
    hasUnicode = __webpack_require__(62689),
    unicodeSize = __webpack_require__(21903);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),

/***/ 83140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(44286),
    hasUnicode = __webpack_require__(62689),
    unicodeToArray = __webpack_require__(676);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 21903:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),

/***/ 676:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 96347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(23933),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 39138:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531),
    castSlice = __webpack_require__(40180),
    hasUnicode = __webpack_require__(62689),
    isObject = __webpack_require__(13218),
    isRegExp = __webpack_require__(96347),
    stringSize = __webpack_require__(88016),
    stringToArray = __webpack_require__(83140),
    toInteger = __webpack_require__(40554),
    toString = __webpack_require__(79833);

/** Used as default options for `_.truncate`. */
var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */
function truncate(string, options) {
  var length = DEFAULT_TRUNC_LENGTH,
      omission = DEFAULT_TRUNC_OMISSION;

  if (isObject(options)) {
    var separator = 'separator' in options ? options.separator : separator;
    length = 'length' in options ? toInteger(options.length) : length;
    omission = 'omission' in options ? baseToString(options.omission) : omission;
  }
  string = toString(string);

  var strLength = string.length;
  if (hasUnicode(string)) {
    var strSymbols = stringToArray(string);
    strLength = strSymbols.length;
  }
  if (length >= strLength) {
    return string;
  }
  var end = length - stringSize(omission);
  if (end < 1) {
    return omission;
  }
  var result = strSymbols
    ? castSlice(strSymbols, 0, end).join('')
    : string.slice(0, end);

  if (separator === undefined) {
    return result + omission;
  }
  if (strSymbols) {
    end += (result.length - end);
  }
  if (isRegExp(separator)) {
    if (string.slice(end).search(separator)) {
      var match,
          substring = result;

      if (!separator.global) {
        separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
      }
      separator.lastIndex = 0;
      while ((match = separator.exec(substring))) {
        var newEnd = match.index;
      }
      result = result.slice(0, newEnd === undefined ? end : newEnd);
    }
  } else if (string.indexOf(baseToString(separator), end) != end) {
    var index = result.lastIndexOf(separator);
    if (index > -1) {
      result = result.slice(0, index);
    }
  }
  return result + omission;
}

module.exports = truncate;


/***/ }),

/***/ 13294:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.cityIn = cityIn;
exports.cityFrom = cityFrom;
exports.cityTo = cityTo;

var _utils = __webpack_require__(40627);

var _gender = __webpack_require__(22932);

var _inclineRules = __webpack_require__(90544);

var _incline = __webpack_require__(74234);

var _cityRules = __webpack_require__(26923);

/* eslint-disable no-use-before-define, no-continue, arrow-parens */
(0, _inclineRules.constantizeGenderInRules)(_cityRules.cityRules);

function declineTo(name, wordCase, gender) {
  if (isFrozen(name, _cityRules.frozenWords)) return name;
  return name.split(/(\s|-)/g).map(function (part, i, parts) {
    if (isFrozenPart(part, i, parts)) return part;
    var rule = (0, _inclineRules.findRule)(part, _gender.ANDROGYNOUS, _cityRules.cityRules);

    if (rule) {
      return (0, _inclineRules.applyRule)(rule, part, wordCase);
    }

    return (0, _incline.inclineFirstname)(part, wordCase, gender) || part;
  }).join('');
} // предложный, в каком городе живете/находитесь?


function cityIn(name, gender) {
  return declineTo(name, _inclineRules.PREPOSITIONAL, gender);
} // родительный, из какого города приехали?


function cityFrom(name, gender) {
  return declineTo(name, _inclineRules.GENITIVE, gender);
} // винительный, в какой город направляетесь?


function cityTo(name) {
  if (!name) return name;
  return name.split(/(\s|-)/g).map(function (part, i, parts) {
    if (isFrozenPart(part, i, parts)) return part;
    var partLower = part.toLowerCase();

    if ((0, _utils.endsWith)(partLower, 'а')) {
      return (0, _inclineRules.applyMod)(part, '-у');
    } else if ((0, _utils.endsWith)(partLower, 'ая')) {
      return (0, _inclineRules.applyMod)(part, '--ую');
    } else if ((0, _utils.endsWith)(partLower, 'ия')) {
      return (0, _inclineRules.applyMod)(part, '--ию');
    } else if ((0, _utils.endsWith)(partLower, 'я')) {
      return (0, _inclineRules.applyMod)(part, '-ю');
    }

    return part;
  }).join('');
}

function isFrozen(str, words) {
  var strLower = str.toLowerCase();

  for (var k = 0; k < words.length; k++) {
    if (words[k] === strLower) {
      return true;
    }
  }

  return false;
}

function isFrozenPart(part, i, parts) {
  if (parts.length > 1) {
    if (isFrozen(part, _cityRules.frozenParts)) return true;

    for (var k = 0; k < i; k++) {
      if (isFrozen(parts[k], _cityRules.frozenPartsAfter)) return true;
    }
  }

  return false;
}

/***/ }),

/***/ 22932:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getFG = getFG;
exports.getLG = getLG;
exports.getMG = getMG;
exports.getFirstnameGender = getFirstnameGender;
exports.getLastnameGender = getLastnameGender;
exports.getMiddlenameGender = getMiddlenameGender;
exports.mergeGenders = mergeGenders;
exports._getGender = _getGender;
exports.getGender = getGender;
exports.getGenderByRuleSet = getGenderByRuleSet;
exports.getGenderByRule = getGenderByRule;
exports.getGenderConst = getGenderConst;
exports.convertGenderStr = convertGenderStr;
exports.ANDROGYNOUS = exports.FEMALE = exports.MALE = void 0;

var _utils = __webpack_require__(40627);

var _genderRules = _interopRequireDefault(__webpack_require__(58702));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-use-before-define, arrow-parens */
var MALE = 1;
exports.MALE = MALE;
var FEMALE = 2;
exports.FEMALE = FEMALE;
var ANDROGYNOUS = 4;
exports.ANDROGYNOUS = ANDROGYNOUS;

function getFG(str) {
  return getGenderByRuleSet(str, _genderRules.default.firstname);
}

function getLG(str) {
  return getGenderByRuleSet(str, _genderRules.default.lastname);
}

function getMG(str) {
  return getGenderByRuleSet(str, _genderRules.default.middlename);
}

function getFirstnameGender(str) {
  return convertGenderStr(getFG(str));
}

function getLastnameGender(str) {
  return convertGenderStr(getLG(str));
}

function getMiddlenameGender(str) {
  return convertGenderStr(getMG(str));
}

function mergeGenders(g1, g2) {
  if (g1 === ANDROGYNOUS) return g2;
  if (g2 === ANDROGYNOUS) return g1;
  if (g1 === g2) return g1;
  return null;
}

function _getGender(fio) {
  var result = ANDROGYNOUS;

  if (fio.middle) {
    result = mergeGenders(result, getMG(fio.middle.trim()));
  }

  if (fio.first) {
    result = mergeGenders(result, getFG(fio.first.trim()));
  }

  if (fio.last) {
    var lastGender = getLG(fio.last.trim());

    if (lastGender !== null) {
      result = mergeGenders(result, lastGender);
    }
  }

  return result;
}

function getGender(fio) {
  return convertGenderStr(_getGender(fio));
}

function getGenderByRuleSet(name, ruleSet) {
  if (!name || !ruleSet) {
    return null;
  }

  var nameLower = name.toLowerCase();

  if (ruleSet.exceptions) {
    var gender = getGenderByRule(ruleSet.exceptions, function (some) {
      if ((0, _utils.startsWith)(some, '-')) {
        return (0, _utils.endsWith)(nameLower, some.substr(1));
      }

      return some === nameLower;
    });
    if (gender) return gender;
  }

  return ruleSet.suffixes ? getGenderByRule(ruleSet.suffixes, function (some) {
    return (0, _utils.endsWith)(nameLower, some);
  }) : null;
}

function getGenderByRule(rules, matchFn) {
  var genders = Object.keys(rules).filter(function (genderKey) {
    var array = rules[genderKey];
    return Array.isArray(array) && array.some(matchFn);
  });

  if (genders.length !== 1) {
    // DEBUG SEVERAL RULES
    Object.keys(rules).forEach(function (genderKey) {
      var array = rules[genderKey];

      if (Array.isArray(array) && array.some(matchFn)) {// eslint-disable-next-line
        // console.log(genderKey, array);
      }
    });
    return null;
  }

  return getGenderConst(genders[0]);
}

function getGenderConst(key) {
  switch (key) {
    case 'male':
    case MALE:
      return MALE;

    case 'female':
    case FEMALE:
      return FEMALE;

    case 'androgynous':
    case ANDROGYNOUS:
      return ANDROGYNOUS;

    default:
      return null;
  }
}

function convertGenderStr(cnst) {
  switch (cnst) {
    case 'male':
    case MALE:
      return 'male';

    case 'female':
    case FEMALE:
      return 'female';

    case 'androgynous':
    case ANDROGYNOUS:
      return 'androgynous';

    default:
      return null;
  }
}

/***/ }),

/***/ 74234:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.inclineFirstname = inclineFirstname;
exports.inclineLastname = inclineLastname;
exports.inclineMiddlename = inclineMiddlename;
exports.incline = incline;

var _gender = __webpack_require__(22932);

var _inclineRules = __webpack_require__(90544);

var _inclineRulesLastname = _interopRequireDefault(__webpack_require__(61303));

var _inclineRulesMiddlename = _interopRequireDefault(__webpack_require__(8344));

var _inclineRulesFirstname = _interopRequireDefault(__webpack_require__(7806));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-use-before-define, no-continue, arrow-parens */
(0, _inclineRules.constantizeGenderInRules)(_inclineRulesLastname.default);
(0, _inclineRules.constantizeGenderInRules)(_inclineRulesMiddlename.default);
(0, _inclineRules.constantizeGenderInRules)(_inclineRulesFirstname.default);

function inclineFirstname(str) {
  var declension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accusative';
  var gender = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _inclineRules.inclineByRules)(str, declension, gender || (0, _gender.getFG)(str), _inclineRulesFirstname.default);
}

function inclineLastname(str) {
  var declension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accusative';
  var gender = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _inclineRules.inclineByRules)(str, declension, gender || (0, _gender.getLG)(str), _inclineRulesLastname.default);
}

function inclineMiddlename(str) {
  var declension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accusative';
  var gender = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _inclineRules.inclineByRules)(str, declension, gender || (0, _gender.getMG)(str), _inclineRulesMiddlename.default);
}

function incline(person, declension) {
  var res = {};

  if (!res.gender) {
    res.gender = (0, _gender.getGender)(person);
  }

  if (person.first) {
    res.first = inclineFirstname(person.first.trim(), declension, res.gender);
  }

  if (person.last) {
    res.last = inclineLastname(person.last.trim(), declension, res.gender);
  }

  if (person.middle) {
    res.middle = inclineMiddlename(person.middle.trim(), declension, res.gender);
  }

  return res;
}

/***/ }),

/***/ 90544:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.constantizeGenderInRules = constantizeGenderInRules;
exports.inclineByRules = inclineByRules;
exports.findRule = findRule;
exports.findExactRule = findExactRule;
exports.applyRule = applyRule;
exports.applyMod = applyMod;
exports.getDeclensionConst = getDeclensionConst;
exports.getDeclensionStr = getDeclensionStr;
exports.PREPOSITIONAL = exports.INSTRUMENTAL = exports.ACCUSATIVE = exports.DATIVE = exports.GENITIVE = exports.NOMINATIVE = void 0;

var _utils = __webpack_require__(40627);

var _gender = __webpack_require__(22932);

/* eslint-disable no-use-before-define, no-continue, arrow-parens */
var NOMINATIVE = 1; // именительный

exports.NOMINATIVE = NOMINATIVE;
var GENITIVE = 2; // родительный

exports.GENITIVE = GENITIVE;
var DATIVE = 3; // дательный

exports.DATIVE = DATIVE;
var ACCUSATIVE = 4; // винительный

exports.ACCUSATIVE = ACCUSATIVE;
var INSTRUMENTAL = 5; // творительный

exports.INSTRUMENTAL = INSTRUMENTAL;
var PREPOSITIONAL = 6; // предложный

exports.PREPOSITIONAL = PREPOSITIONAL;

function constantizeGenderInRules(rules) {
  if (Array.isArray(rules.exceptions)) {
    rules.exceptions.forEach(function (rule) {
      rule.gender = (0, _gender.getGenderConst)(rule.gender); // eslint-disable-line
    });
  }

  if (Array.isArray(rules.suffixes)) {
    rules.suffixes.forEach(function (rule) {
      rule.gender = (0, _gender.getGenderConst)(rule.gender); // eslint-disable-line
    });
  }
}

function inclineByRules(str, declensionStr, genderStr, ruleSet) {
  var declension = getDeclensionConst(declensionStr);
  var gender = (0, _gender.getGenderConst)(genderStr);
  var parts = str.split('-');
  var result = [];

  for (var i = 0; i < parts.length; i++) {
    var part = parts[i];
    var isFirstWord = i === 0 && parts.length > 1;
    var rule = findRule(part, gender, ruleSet, {
      firstWord: isFirstWord
    });

    if (rule) {
      result.push(applyRule(rule, part, declension));
    } else {
      result.push(part);
    }
  }

  return result.join('-');
}

function findRule(str, gender, ruleSet) {
  var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!str) {
    return null;
  }

  var strLower = str.toLowerCase();
  var tagList = [];
  Object.keys(tags).forEach(function (key) {
    if (tags[key]) {
      tagList.push(key);
    }
  });

  if (ruleSet.exceptions) {
    var rule = findExactRule(ruleSet.exceptions, gender, function (some) {
      return some === strLower;
    }, tagList);
    if (rule) return rule;
  }

  return ruleSet.suffixes ? findExactRule(ruleSet.suffixes, gender, function (some) {
    return (0, _utils.endsWith)(strLower, some);
  }, tagList) : null;
}

function findExactRule(rules, gender, matchFn) {
  var tags = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  for (var i = 0; i < rules.length; i++) {
    var rule = rules[i]; // rule with tag should be skipped if tag not listed in args

    if (rule.tags) {
      if (!rule.tags.find(function (t) {
        return tags.indexOf(t) !== -1;
      })) {
        continue;
      }
    } // rule must have same gender or be `androgynous`


    if (rule.gender !== _gender.ANDROGYNOUS && gender !== rule.gender) {
      continue;
    }

    if (rule.test) {
      for (var j = 0; j < rule.test.length; j++) {
        if (matchFn(rule.test[j])) {
          return rule;
        }
      }
    }
  }

  return null;
}

function getModByIdx(mods, i) {
  if (mods && mods.length >= i) {
    return mods[i];
  }

  return '.';
}

function applyRule(rule, str, declension) {
  var mod;

  switch (declension) {
    case NOMINATIVE:
      mod = '.';
      break;

    case GENITIVE:
      mod = getModByIdx(rule.mods, 0);
      break;

    case DATIVE:
      mod = getModByIdx(rule.mods, 1);
      break;

    case ACCUSATIVE:
      mod = getModByIdx(rule.mods, 2);
      break;

    case INSTRUMENTAL:
      mod = getModByIdx(rule.mods, 3);
      break;

    case PREPOSITIONAL:
      mod = getModByIdx(rule.mods, 4);
      break;

    default:
      mod = '.';
  }

  return applyMod(str, mod);
}

function applyMod(str, mod) {
  for (var i = 0; i < mod.length; i++) {
    var chr = mod[i];

    switch (chr) {
      case '.':
        break;

      case '-':
        str = str.substr(0, str.length - 1); // eslint-disable-line no-param-reassign

        break;

      default:
        str += chr;
      // eslint-disable-line no-param-reassign
    }
  }

  return str;
}

function getDeclensionConst(key) {
  switch (key) {
    case 'nominative':
    case NOMINATIVE:
      return NOMINATIVE;

    case 'genitive':
    case GENITIVE:
      return GENITIVE;

    case 'dative':
    case DATIVE:
      return DATIVE;

    case 'accusative':
    case ACCUSATIVE:
      return ACCUSATIVE;

    case 'instrumental':
    case INSTRUMENTAL:
      return INSTRUMENTAL;

    case 'prepositional':
    case PREPOSITIONAL:
      return PREPOSITIONAL;

    default:
      return null;
  }
}

function getDeclensionStr(cnst) {
  switch (cnst) {
    case 'nominative':
    case NOMINATIVE:
      return 'nominative';

    case 'genitive':
    case GENITIVE:
      return 'genitive';

    case 'dative':
    case DATIVE:
      return 'dative';

    case 'accusative':
    case ACCUSATIVE:
      return 'accusative';

    case 'instrumental':
    case INSTRUMENTAL:
      return 'instrumental';

    case 'prepositional':
    case PREPOSITIONAL:
      return 'prepositional';

    default:
      return null;
  }
}

/***/ }),

/***/ 80297:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _incline.incline;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _incline.inclineFirstname;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _incline.inclineLastname;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _incline.inclineMiddlename;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _gender.getFirstnameGender;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _gender.getLastnameGender;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _gender.getMiddlenameGender;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _gender.getGender;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _city.cityIn;
  }
});
Object.defineProperty(exports, "R7", ({
  enumerable: true,
  get: function get() {
    return _city.cityFrom;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _city.cityTo;
  }
});

var _incline = __webpack_require__(74234);

var _gender = __webpack_require__(22932);

var _city = __webpack_require__(13294);

/***/ }),

/***/ 26923:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.cityRules = exports.frozenPartsAfter = exports.frozenParts = exports.frozenWords = void 0;

var _gender = __webpack_require__(22932);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var frozenWords = ['форт-шевченко'];
exports.frozenWords = frozenWords;
var frozenParts = ['-', ' ', 'в', 'на', 'баден', // баден-Бадене
'бледно', 'буэнос', 'вице', // вице-президенту
'гаврилов', 'йошкар', // Йошкар-Ола
'коста', 'лос', 'норд', 'нью', // Нью-Йорку,
'орехово', 'принс', 'сан', // Сан-Франциско
'санкт', // Санкт-Петербург
'санта', 'северо', 'ситтард', 'темно', 'улан', 'усолье', // Усолье-Сибирское
'усть', // Усть-Каменогорске, Усть-Илимск
'форт', // Форт-Шевченко
'царь', // царь-пушке
'экс', // экс-чемпиону
'юго', 'юрьев', 'нур']; // do not decline words after this words

exports.frozenParts = frozenParts;
var frozenPartsAfter = ['село', 'поселок', 'аул', 'город', 'деревня', 'урочище'];
exports.frozenPartsAfter = frozenPartsAfter;
var cityInflections = {
  exceptions: [{
    test: ['сочи', 'тбилиси'],
    mods: ['', '', '', '', '']
  }, {
    test: ['село', 'озеро', 'место'],
    mods: ['-а', '-у', '', 'м', '-е']
  }, {
    test: ['область'],
    mods: ['-и', '-и', '', 'ю', '-и']
  }, {
    test: ['деревня'],
    mods: ['-и', '-е', '-ю', '-ей', '-е']
  }, {
    test: ['море'],
    mods: ['-я', '-ю', '', 'м', '']
  }, {
    test: ['холм'],
    mods: ['а', 'у', '', 'ом', 'е']
  }, {
    test: ['орел', 'орёл'],
    // Орел, Орёл
    mods: ['--ла', '--лу', '--ла', '--лом', '--ле']
  }, {
    test: ['крым'],
    mods: ['-ма', '-му', '-ма', '-ом', '-му']
  }],
  suffixes: [{
    test: ['чёк', 'чек'],
    // Волочёк, Чернечек
    mods: ['--ка', '--ку', '', '--ком', '--ке']
  }, {
    test: ['чик', 'ич'],
    // Чик, Углич
    mods: ['а', 'у', '', 'ом', 'е']
  }, {
    test: ['жний', 'хний', 'шний', 'щий'],
    // Нижний, Вышний, Верхний
    mods: ['--его', '--ему', '', '-м', '--ем']
  }, {
    test: ['ще'],
    // Хлевище, Городище
    mods: ['-а', '-у', '', 'м', '']
  }, {
    test: ['щи'],
    // Мытищи
    mods: ['-', '-ам', '', '-ами', '-ах']
  }, {
    test: ['чье'],
    // Щучье
    mods: ['-я', '-ю', '', 'м', '']
  }, {
    test: ['ель', 'пль'],
    // норильский никель, Гузерипль
    mods: ['-я', '-ю', '', '-ем', '-е']
  }, {
    test: ['чь'],
    // Холмечь
    mods: ['-и', '-и', '', 'ю', '-и']
  }, {
    test: ['чи'],
    // Чепеничи
    mods: ['-ей', '-ам', '', '-ами', '-ах']
  }, {
    test: ['ые', 'ие'],
    // Набережные
    mods: ['-х', '-м', '', '-ми', '-х']
  }, {
    test: ['ый', 'ий', 'ое'],
    // Рижский, Раменское
    mods: ['--ого', '--ому', '', '-м', '--ом']
  }, {
    test: ['ая'],
    // Рижская
    mods: ['--ой', '--ой', '--ую', '--ой', '--ой']
  }, {
    test: ['гиев'],
    // Сергиев Посад, но не Киев
    mods: ['а', 'у', '', 'ым', 'ом']
  }, {
    test: ['ны', 'вцы'],
    // Челны, Черновцы
    mods: ['-ов', '-ам', '', '-ами', '-ах']
  }, {
    test: ['ша'],
    // Ропша
    mods: ['-и', '-е', '-у', '-ей', '-е']
  }, {
    test: ['ры', // Чебоксары, Шушары
    'цы', // Бельцы
    'ды', // минеральные воды
    'ги'],
    mods: ['-', '-ам', '', '-ами', '-ах']
  }, {
    test: ['амень'],
    // Камень, но не Тюмень
    mods: ['---ня', '---ню', '', '---нем', '---не']
  }, {
    test: ['ьн', // Кёльн
    'нц', // Гленц
    'мм'],
    mods: ['а', 'у', '', 'ом', 'е']
  }] // Склонения городов можно подсмотреть тут https://ru.wiktionary.org/wiki/%D0%9A%D1%91%D0%BB%D1%8C%D0%BD

};
var cityRules = {
  exceptions: cityInflections.exceptions.map(function (o) {
    return _objectSpread({
      gender: _gender.ANDROGYNOUS
    }, o);
  }),
  suffixes: cityInflections.suffixes.map(function (o) {
    return _objectSpread({
      gender: _gender.ANDROGYNOUS
    }, o);
  })
};
exports.cityRules = cityRules;

/***/ }),

/***/ 58702:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var middlename = {
  suffixes: {
    female: ['на', 'кызы', 'гызы'],
    male: ['ич', 'оглы', 'улы', 'уулу']
  }
};
var lastname = {
  exceptions: {
    androgynous: ['бова', 'регин', 'дарвин', 'пэйлин', 'грин', 'цин', 'шенгелая']
  },
  suffixes: {
    androgynous: ['ан', 'ко', 'дзе', 'швили', 'ян', 'к', 'ер', 'ц', 'г', 'йн', 'дт', 'ен', 'ич', 'о', 'ун'],
    female: ['ова', 'ая', 'ына', 'ина', 'ева', 'ска', 'ёва'],
    male: ['кий', 'ов', 'ын', 'ев', 'ин', 'ёв', 'хий', 'ний', 'ый', 'ой']
  }
};
var firstname = {
  exceptions: {
    androgynous: ['анри', 'алвард', 'валери', 'женя', 'закия', 'захария', 'иона', 'кири', 'ким', 'муса', 'райхон', 'саша', 'сева', 'ардак', 'арман', 'асыл', 'баглан', 'бакыт', 'бахыт', 'еркежан', 'жанат', 'жаркын', 'куаныш', 'манат', 'мереке', 'рауан', 'сымбат', 'тлеухан', 'умит', 'улжалгас', 'ырыс', 'айбала', 'акбала', 'ирза', 'арши', 'амиль'],
    male: ['аба', 'абиба', 'савва', 'лёва', 'вова', '-ага', 'агга', 'серега', 'алиада', 'муктада', 'абида', 'алда', 'маджуда', 'нурлыхуда', 'гиа', 'элиа', 'гарсиа', 'вавила', 'гавриила', 'генка', 'лука', 'дима', 'зосима', 'тима', 'фима', 'фома', 'кузьма', 'жора', 'миша', 'ермила', 'данила', 'гаврила', 'абдалла', 'аталла', 'абдилла', 'атилла', 'кайролла', 'абула', 'свитлана', 'бена', 'гена', 'агелина', 'джанна', 'кришна', 'степа', 'дра', 'назера', 'валера', 'эстера', 'двойра', 'калистра', 'заратустра', 'юра', 'иса', 'аиса', 'халиса', 'холиса', 'валенса', 'мусса', 'ата', 'паата', 'алета', 'никита', 'мота', 'шота', 'фаста', 'коста', 'маритта', 'малюта', 'васюта', 'вафа', 'мустафа', 'ганифа', 'лев', 'яков', 'константин', 'марсель', 'рамиль', 'эмиль', 'бактыгуль', 'даниэль', 'игорь', 'арминэ', 'изя', 'кузя', 'гия', 'мазия', 'кирикия', 'ркия', 'еркия', 'эркия', 'гулия', 'аксания', 'закария', 'зекерия', 'гарсия', 'шендля', 'филя', 'вилля', 'толя', 'коля', 'ваня', 'саня', 'загиря', 'боря', 'цайся', 'вася', 'ося', 'петя', 'витя', 'митя', 'костя', 'илья', 'абдала', 'абдель', 'фидель', 'фридель', 'абдилла', 'аталла', 'абла', 'лазарь', 'ава', 'вовка', 'семён'],
    female: ['судаба', 'сураба', 'любава', 'джанлука', 'варвара', 'наташа', 'зайнаб', 'любов', 'сольвейг', 'шакед', 'аннаид', 'ингрид', 'синди', 'аллаберди', 'лали', 'натали', 'лили', 'нелли', 'элли', 'эмили', 'амили', 'адели', 'гулькай', 'алтынай', 'гюнай', 'гюльчитай', 'нурангиз', 'лиз', 'элиз', 'ботагоз', 'юлдуз', 'диляфруз', 'габи', 'сажи', 'фанни', 'мери', 'элдари', 'эльдари', 'хилари', 'хиллари', 'аннемари', 'розмари', 'товсари', 'ансари', 'одри', 'тери', 'ири', 'катя', 'катри', 'мэри', 'сатаней', 'ефтений', 'верунчик', 'гюзел', 'этел', 'рэйчел', 'джил', 'мерил', 'нинелл', 'бурул', 'ахлам', 'майрам', 'махаррам', 'мириам', 'дилярам', 'асем', 'мерьем', 'мирьем', 'эркаим', 'гулаим', 'айгерим', 'марьям', 'мирьям', 'эван', 'гульжиган', 'айдан', 'айжан', 'вивиан', 'гульжиан', 'лилиан', 'мариан', 'саиман', 'джоан', 'чулпан', 'лоран', 'моран', 'гульшан', 'аделин', 'жаклин', 'карин', 'каролин', 'каталин', 'катрин', 'керстин', 'кэтрин', 'мэрилин', 'рузалин', 'хелин', 'цеткин', 'ширин', 'элисон', 'дурсун', 'кристин', 'гульжиян', 'марьян', 'ренато', 'зейнеп', 'санабар', 'дильбар', 'гулизар', 'гульзар', 'пилар', 'дагмар', 'элинар', 'нилуфар', 'анхар', 'гаухар', 'естер', 'эстер', 'дженнифер', 'линор', 'элинор', 'элеонор', 'айнур', 'гульнур', 'шамсинур', 'элнур', 'ильсияр', 'нигяр', 'сигитас', 'агнес', 'анес', 'долорес', 'инес', 'анаис', 'таис', 'эллис', 'элис', 'кларис', 'амнерис', 'айрис', 'дорис', 'беатрис', 'грейс', 'грэйс', 'ботагос', 'маргос', 'джулианс', 'арус', 'диляфрус', 'саодат', 'зулхижат', 'хамат', 'патимат', 'хатимат', 'альжанат', 'маймунат', 'гульшат', 'рут', 'иргаш', 'айнаш', 'агнеш', 'зауреш', 'тэрбиш', 'ануш', 'азгануш', 'гаруш', 'николь', 'адась', 'адула', 'ахмадула', 'гейбадула', 'лив', 'ираги', 'пегги', 'абдурефи', 'адерми', 'лакшми', 'мими', 'наоми', 'изабель', 'абигейль', 'зебо', 'аширбу', 'судаба', 'айсулу', 'айши', 'жанет', 'гузаль', 'сапият', 'зауре', 'кармен', 'мадлен', 'алсу', 'айсу', 'амели', '-бану', 'ассоль', 'николь']
  },
  suffixes: {
    androgynous: ['щи', // Мытищи
    'ки'],
    male: ['аба', 'б', 'ав', 'ев', 'ов', 'во', 'г', 'д', 'ж', 'з', 'би', 'ди', 'жи', 'ли', 'гани', 'ит', 'до', 'айт', 'юм', 'дула', 'ив', 'ги', 'улла', 'улль', 'фи', 'аль', 'ми', 'бель', 'була', 'йль', 'яй', 'бо', 'бу', 'кр', 'ыль', 'ыт', 'вва', 'вель', 'вни', 'аба', 'бала', 'улу', 'рза', 'ши', 'паша', 'го', 'но', 'ет', 'ят', 'ре', 'ри', 'ай', 'ей', 'ий', 'ой', 'ый', 'к', 'л', 'ам', 'ем', 'им', 'ом', 'ум', 'ым', 'ям', 'ан', 'бен', 'вен', 'ген', 'ден', 'ин', 'сейн', 'он', 'ун', 'ян', 'ио', 'ло', 'ро', 'то', 'шо', 'п', 'ар', 'др', 'ер', 'ир', 'ор', 'тр', 'ур', 'ыр', 'яр', 'ас', 'ес', 'ис', 'йс', 'кс', 'мс', 'ос', 'нс', 'рс', 'ус', 'юс', 'яс', 'ат', 'кт', 'нт', 'рт', 'ст', 'ут', 'ф', 'х', 'ш', 'ы', 'сь', 'тау', // Актау, Ерейментау, Каратау, Кокшетау, Кентау
    'ен', // Жанаозен, Каскелен
    'коль', // Акколь
    'рау', // Атырау
    'обе', // Актобе, Уштобе
    'убе', 'иль', // Есиль, Адиль
    'ево', // Булаево
    'ово', // Медведково
    'шу', // Шу,
    'ду', // Катманду
    'пуль', // Ливерпуль
    'нко', // Ливерпуль
    'су', // Аксу, Карасу
    'вль', // Ярославль
    'оль', // Ставрополь, Севастополь, Симферополь
    'ёв', // город Королёв
    'ём', // Артём
    'ец', // Елец, Череповец
    'сс', // Миасс
    'льс', // Энгельс
    'хт', // Утрехт
    'рн', // Апелдорн
    'дт'],
    female: ['иба', 'люба', 'лава', 'ева', 'га', 'да', 'еа', 'иза', 'иа', 'ика', 'нка', 'ска', 'ела', 'ила', 'илла', 'эла', 'има', 'на', 'ра', 'са', 'та', 'фа', 'еса', 'сса', 'гуль', 'куль', 'нуэль', 'гюль', 'нэ', 'ая', 'ея', 'ия', 'йя', 'ля', 'мя', 'оя', 'ря', 'ся', 'вья', 'лья', 'мья', 'нья', 'рья', 'сья', 'тья', 'фья', 'зя', 'нша', // Тайынша
    'ха', // Шемонаиха
    'тка', // Мамлютка
    'нь', // Сарань, Тюмень
    'чь', // Сарань, Керчь
    'мь', // Сарань, Пермь
    'ерь', // Тверь
    'овка', // Покровка
    'евка', // Сергеевка
    'мба', // Эмба
    'зь', // Бизь, Грязь
    'лка', 'сала', 'бла', 'арь', 'ума', 'пи', 'дель', 'не', 'жка', 'си', 'ибе', 'абе', 'елла', 'ие', 'фе', 'фя']
  }
};
var rulesGender = {
  lastname: lastname,
  firstname: firstname,
  middlename: middlename
};
var _default = rulesGender;
exports["default"] = _default;

/***/ }),

/***/ 7806:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var name = {
  exceptions: [{
    gender: 'male',
    test: ['лев'],
    mods: ['--ьва', '--ьву', '--ьва', '--ьвом', '--ьве']
  }, {
    gender: 'male',
    test: ['пётр'],
    mods: ['---етра', '---етру', '---етра', '---етром', '---етре']
  }, {
    gender: 'male',
    test: ['павел'],
    mods: ['--ла', '--лу', '--ла', '--лом', '--ле']
  }, {
    gender: 'male',
    test: ['яша'],
    mods: ['-и', '-е', '-у', '-ей', '-е']
  }, {
    gender: 'male',
    test: ['шота'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'female',
    test: ['агидель', 'жизель', 'нинель', 'рашель', 'рахиль'],
    mods: ['-и', '-и', '.', 'ю', '-и']
  }],
  suffixes: [{
    gender: 'androgynous',
    test: ['лок'],
    mods: ['--ка', '--ку', '.', '--кос', '--ке']
  }, {
    gender: 'androgynous',
    test: ['ки'],
    mods: ['-ов', '-ам', '.', '-ами', '-ах']
  }, {
    gender: 'androgynous',
    test: ['щи'],
    mods: ['-ев', '-ам', '.', '-ами', '-ах']
  }, {
    gender: 'androgynous',
    test: ['е', 'ё', 'и', 'о', 'у', 'ы', 'э', 'ю'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'male',
    test: ['уа', 'иа'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'female',
    test: ['б', 'в', 'г', 'д', 'ж', 'з', 'й', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'иа', 'ль'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'female',
    test: ['ь'],
    mods: ['-и', '-и', '.', 'ю', '-и']
  }, {
    gender: 'male',
    test: ['ь'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }, {
    gender: 'androgynous',
    test: ['га', 'ка', 'ха', 'ча', 'ща', 'жа'],
    mods: ['-и', '-е', '-у', '-ой', '-е']
  }, {
    gender: 'female',
    test: ['ша'],
    mods: ['-и', '-е', '-у', '-ей', '-е']
  }, {
    gender: 'male',
    test: ['ша', 'ча', 'жа'],
    mods: ['-и', '-е', '-у', '-ей', '-е']
  }, {
    gender: 'androgynous',
    test: ['а'],
    mods: ['-ы', '-е', '-у', '-ой', '-е']
  }, {
    gender: 'female',
    test: ['ия'],
    mods: ['-и', '-и', '-ю', '-ей', '-и']
  }, {
    gender: 'female',
    test: ['ка', 'га', 'ха'],
    mods: ['-и', '-е', '-у', '-ой', '-е']
  }, {
    gender: 'female',
    test: ['ца'],
    mods: ['-ы', '-е', '-у', '-ей', '-е']
  }, {
    gender: 'female',
    test: ['а'],
    mods: ['-ы', '-е', '-у', '-ой', '-е']
  }, {
    gender: 'female',
    test: ['я'],
    mods: ['-и', '-е', '-ю', '-ей', '-е']
  }, {
    gender: 'male',
    test: ['ия'],
    mods: ['-и', '-и', '-ю', '-ей', '-и']
  }, {
    gender: 'male',
    test: ['я'],
    mods: ['-и', '-е', '-ю', '-ей', '-е']
  }, {
    gender: 'male',
    test: ['ий'],
    mods: ['-я', '-ю', '-я', '-ем', '-и']
  }, // @NODKZ Рудный
  {
    gender: 'male',
    test: ['ый', 'кий', 'хий'],
    mods: ['--ого', '--ому', '--ого', '-м', '--ом']
  }, {
    gender: 'male',
    test: ['ей', 'й'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }, {
    gender: 'male',
    test: ['ш', 'ж'],
    mods: ['а', 'у', 'а', 'ем', 'е']
  }, {
    gender: 'male',
    test: ['ёл'],
    mods: ['--ла', '--лу', '--ла', '--лом', '--ле']
  }, {
    gender: 'male',
    test: ['ёк'],
    mods: ['--ька', '--ьку', '--ька', '--ьком', '--ьке']
  }, {
    gender: 'male',
    test: ['б', 'в', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'androgynous',
    test: ['ния', 'рия', 'вия'],
    mods: ['-и', '-и', '-ю', '-ем', '-ем']
  }]
};
var _default = name;
exports["default"] = _default;

/***/ }),

/***/ 61303:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var lastname = {
  exceptions: [{
    gender: 'androgynous',
    test: ['бонч', 'абдул', 'белиц', 'гасан', 'дюссар', 'дюмон', 'книппер', 'корвин', 'ван', 'шолом', 'тер', 'призван', 'мелик', 'вар', 'фон'],
    mods: ['.', '.', '.', '.', '.'],
    tags: ['first_word']
  }, {
    gender: 'androgynous',
    test: ['дюма', 'тома', 'дега', 'люка', 'ферма', 'гамарра', 'петипа', 'шандра', 'скаля', 'каруана'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'androgynous',
    test: ['гусь', 'ремень', 'камень', 'онук', 'богода', 'нечипас', 'долгопалец', 'маненок', 'рева', 'кива'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'androgynous',
    test: ['вий', 'сой', 'цой', 'хой'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }],
  suffixes: [{
    gender: 'female',
    test: ['б', 'в', 'г', 'д', 'ж', 'з', 'й', 'к', 'л', 'м', 'н', 'п', 'р', 'с', 'т', 'ф', 'х', 'ц', 'ч', 'ш', 'щ', 'ъ', 'ь'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'androgynous',
    test: ['орота'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'female',
    test: ['ска', 'цка'],
    mods: ['-ой', '-ой', '-ую', '-ой', '-ой']
  }, {
    gender: 'female',
    test: ['цкая', 'ская', 'ная', 'ая'],
    mods: ['--ой', '--ой', '--ую', '--ой', '--ой']
  }, {
    gender: 'female',
    test: ['яя'],
    mods: ['--ей', '--ей', '--юю', '--ей', '--ей']
  }, {
    gender: 'male',
    test: ['иной', 'уй'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }, {
    gender: 'androgynous',
    test: ['ца'],
    mods: ['-ы', '-е', '-у', '-ей', '-е']
  }, {
    gender: 'male',
    test: ['рих'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'androgynous',
    test: ['ия'],
    mods: ['-и', '-и', '-ю', '-ей', '-и']
  }, {
    gender: 'androgynous',
    test: ['иа', 'аа', 'оа', 'уа', 'ыа', 'еа', 'юа', 'эа'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'androgynous',
    test: ['о', 'е', 'э', 'и', 'ы', 'у', 'ю'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'male',
    test: ['их', 'ых'],
    mods: ['.', '.', '.', '.', '.']
  }, {
    gender: 'female',
    test: ['ова', 'ева', 'на', 'ёва'],
    mods: ['-ой', '-ой', '-у', '-ой', '-ой']
  }, {
    gender: 'androgynous',
    test: ['га', 'ка', 'ха', 'ча', 'ща', 'жа', 'ша'],
    mods: ['-и', '-е', '-у', '-ой', '-е']
  }, {
    gender: 'androgynous',
    test: ['а'],
    mods: ['-ы', '-е', '-у', '-ой', '-е']
  }, {
    gender: 'male',
    test: ['ь'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }, {
    gender: 'androgynous',
    test: ['я'],
    mods: ['-и', '-е', '-ю', '-ей', '-е']
  }, {
    gender: 'male',
    test: ['обей'],
    mods: ['--ья', '--ью', '--ья', '--ьем', '--ье']
  }, {
    gender: 'male',
    test: ['ей'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }, {
    gender: 'male',
    test: ['ян', 'ан', 'йн'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'male',
    test: ['ынец', 'овец'],
    mods: ['--ца', '--цу', '--ца', '--цом', '--це']
  }, {
    gender: 'male',
    test: ['нец', 'обец'],
    mods: ['--ца', '--цу', '--ца', '--цем', '--це']
  }, {
    gender: 'male',
    test: ['ай'],
    mods: ['-я', '-ю', '-я', '-ем', '-е']
  }, {
    gender: 'male',
    test: ['гой', 'кой'],
    mods: ['-го', '-му', '-го', '--им', '-м']
  }, {
    gender: 'male',
    test: ['ой'],
    mods: ['-го', '-му', '-го', '--ым', '-м']
  }, {
    gender: 'male',
    test: ['ах', 'ив', 'шток'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'male',
    test: ['ший', 'щий', 'жий', 'ний'],
    mods: ['--его', '--ему', '--его', '-м', '--ем']
  }, {
    gender: 'male',
    test: ['ый', 'кий', 'хий'],
    mods: ['--ого', '--ому', '--ого', '-м', '--ом']
  }, {
    gender: 'male',
    test: ['ий'],
    mods: ['-я', '-ю', '-я', '-ем', '-и']
  }, {
    gender: 'male',
    test: ['ок'],
    mods: ['--ка', '--ку', '--ка', '--ком', '--ке']
  }, {
    gender: 'male',
    test: ['иец', 'еец'],
    mods: ['--йца', '--йцу', '--йца', '--йцом', '--йце']
  }, {
    gender: 'male',
    test: ['ец'],
    mods: ['--ца', '--цу', '--ца', '--цом', '--це']
  }, {
    gender: 'male',
    test: ['ц', 'ч', 'ш', 'щ'],
    mods: ['а', 'у', 'а', 'ем', 'е']
  }, {
    gender: 'male',
    test: ['ен', 'нн', 'он', 'ун', 'б', 'г', 'д', 'ж', 'з', 'к', 'л', 'м', 'п', 'р', 'с', 'т', 'ф', 'х'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'male',
    test: ['в', 'н'],
    mods: ['а', 'у', 'а', 'ым', 'е']
  }]
};
var _default = lastname;
exports["default"] = _default;

/***/ }),

/***/ 8344:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var middlename = {
  exceptions: [{
    gender: 'androgynous',
    test: ['борух'],
    mods: ['.', '.', '.', '.', '.'],
    tags: ['first_word']
  }],
  suffixes: [{
    gender: 'male',
    test: ['мич', 'ьич', 'кич'],
    mods: ['а', 'у', 'а', 'ом', 'е']
  }, {
    gender: 'male',
    test: ['ич'],
    mods: ['а', 'у', 'а', 'ем', 'е']
  }, {
    gender: 'female',
    test: ['на'],
    mods: ['-ы', '-е', '-у', '-ой', '-е']
  }]
};
var _default = middlename;
exports["default"] = _default;

/***/ }),

/***/ 40627:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.endsWith = endsWith;
exports.startsWith = startsWith;

function endsWith(str, search) {
  var strLength = str.length;
  return str.substring(strLength - search.length, strLength) === search;
}

function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}

/***/ }),

/***/ 81341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getClosestBody */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _misc_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76362);


function getClosestBody(el) {
    if (!el) {
        return null;
    }
    else if (el.tagName === 'BODY') {
        return el;
    }
    else if (el.tagName === 'IFRAME') {
        var document_1 = el.contentDocument;
        return document_1 ? document_1.body : null;
    }
    else if (!el.offsetParent) {
        return null;
    }
    return getClosestBody(el.offsetParent);
}
function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1)
        return true;
    if (e.preventDefault)
        e.preventDefault();
    return false;
}
var isIosDevice = _misc_util__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU &&
    window.navigator &&
    window.navigator.platform &&
    /iP(ad|hone|od)/.test(window.navigator.platform);
var bodies = new Map();
var doc = typeof document === 'object' ? document : undefined;
var documentListenerAdded = false;
/* harmony default export */ __webpack_exports__["Z"] = (!doc
    ? function useLockBodyMock(_locked, _elementRef) {
        if (_locked === void 0) { _locked = true; }
    }
    : function useLockBody(locked, elementRef) {
        if (locked === void 0) { locked = true; }
        var bodyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(doc.body);
        elementRef = elementRef || bodyRef;
        var lock = function (body) {
            var bodyInfo = bodies.get(body);
            if (!bodyInfo) {
                bodies.set(body, { counter: 1, initialOverflow: body.style.overflow });
                if (isIosDevice) {
                    if (!documentListenerAdded) {
                        (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__.on)(document, 'touchmove', preventDefault, { passive: false });
                        documentListenerAdded = true;
                    }
                }
                else {
                    body.style.overflow = 'hidden';
                }
            }
            else {
                bodies.set(body, {
                    counter: bodyInfo.counter + 1,
                    initialOverflow: bodyInfo.initialOverflow,
                });
            }
        };
        var unlock = function (body) {
            var bodyInfo = bodies.get(body);
            if (bodyInfo) {
                if (bodyInfo.counter === 1) {
                    bodies.delete(body);
                    if (isIosDevice) {
                        body.ontouchmove = null;
                        if (documentListenerAdded) {
                            (0,_misc_util__WEBPACK_IMPORTED_MODULE_1__/* .off */ .S1)(document, 'touchmove', preventDefault);
                            documentListenerAdded = false;
                        }
                    }
                    else {
                        body.style.overflow = bodyInfo.initialOverflow;
                    }
                }
                else {
                    bodies.set(body, {
                        counter: bodyInfo.counter - 1,
                        initialOverflow: bodyInfo.initialOverflow,
                    });
                }
            }
        };
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            if (locked) {
                lock(body);
            }
            else {
                unlock(body);
            }
        }, [locked, elementRef.current]);
        // clean up, on un-mount
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
            var body = getClosestBody(elementRef.current);
            if (!body) {
                return;
            }
            return function () {
                unlock(body);
            };
        }, []);
    });


/***/ }),

/***/ 34425:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _util = __webpack_require__(37912);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var process = process || { env: {} };

var InlineSVG = function (_React$Component) {
    _inherits(InlineSVG, _React$Component);

    function InlineSVG() {
        _classCallCheck(this, InlineSVG);

        return _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).apply(this, arguments));
    }

    _createClass(InlineSVG, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var children = this.props.children;

            if ("production" !== process.env.NODE_ENV && children != null) {
                console.info('<InlineSVG />: `children` prop will be ignored.');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var Element = void 0,
                __html = void 0,
                svgProps = void 0;

            var _props = this.props,
                element = _props.element,
                raw = _props.raw,
                src = _props.src,
                otherProps = _objectWithoutProperties(_props, ['element', 'raw', 'src']);

            if (raw === true) {
                Element = 'svg';
                svgProps = (0, _util.extractSVGProps)(src);
                __html = (0, _util.getSVGFromSource)(src).innerHTML;
            }
            __html = __html || src;
            Element = Element || element;
            svgProps = svgProps || {};

            return _react2.default.createElement(Element, _extends({}, svgProps, otherProps, { src: null, children: null,
                dangerouslySetInnerHTML: { __html: __html } }));
        }
    }]);

    return InlineSVG;
}(_react2.default.Component);

exports.Z = InlineSVG;


InlineSVG.defaultProps = {
    element: 'i',
    raw: false,
    src: ''
};

InlineSVG.propTypes = {
    src: _propTypes.string.isRequired,
    element: _propTypes.string,
    raw: _propTypes.bool
};

/***/ }),

/***/ 37912:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.convertReactSVGDOMProperty = convertReactSVGDOMProperty;
exports.startsWith = startsWith;
exports.serializeAttrs = serializeAttrs;
exports.getSVGFromSource = getSVGFromSource;
exports.extractSVGProps = extractSVGProps;
// Transform DOM prop/attr names applicable to `<svg>` element but react-limited

function convertReactSVGDOMProperty(str) {
    return str.replace(/[-|:]([a-z])/g, function (g) {
        return g[1].toUpperCase();
    });
}

function startsWith(str, substring) {
    return str.indexOf(substring) === 0;
}

var DataPropPrefix = 'data-';
// Serialize `Attr` objects in `NamedNodeMap`
function serializeAttrs(map) {
    var ret = {};
    for (var prop, i = 0; i < map.length; i++) {
        var key = map[i].name;
        if (key == "class") {
            prop = "className";
        } else if (!startsWith(key, DataPropPrefix)) {
            prop = convertReactSVGDOMProperty(key);
        } else {
            prop = key;
        }

        ret[prop] = map[i].value;
    }
    return ret;
}

function getSVGFromSource(src) {
    var svgContainer = document.createElement('div');
    svgContainer.innerHTML = src;
    var svg = svgContainer.firstElementChild;
    svg.remove ? svg.remove() : svgContainer.removeChild(svg); // deref from parent element
    return svg;
}

// get <svg /> element props
function extractSVGProps(src) {
    var map = getSVGFromSource(src).attributes;
    return map.length > 0 ? serializeAttrs(map) : null;
}

/***/ })

}]);